/* eslint-disable @angular-eslint/no-output-on-prefix */
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { Subscription, filter } from 'rxjs';

type ButtonType = 'ok' | 'save' | 'cancel' | 'close';
const basicWidth = 50;

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    standalone: false,
})
export class DialogComponent implements OnInit, OnDestroy {
    @Input() title = '';
    @Input() buttons = ['ok'] as ButtonType[];
    @Input() width = basicWidth;
    @Input() closable = true;
    @Input() disabled = false;
    @Output() readonly saveClicked = new EventEmitter<void>();
    @Output() readonly cancelClicked = new EventEmitter<void>();
    @Output() readonly okClicked = new EventEmitter<void>();
    @Output() readonly onShow = new EventEmitter<void>();
    @Output() readonly onHide = new EventEmitter<void>();

    vwWidth = `${basicWidth}vw`;
    @Input() visible = false;
    @Output() readonly visibleChange = new EventEmitter<boolean>();
    navigationSubscription: Subscription;

    constructor(private router: Router) {
        this.navigationSubscription = this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((_) => {
            this.hide();
        });
    }

    ngOnInit(): void {
        this.vwWidth = `${this.width}vw`;
    }

    ngOnDestroy(): void {
        this.navigationSubscription.unsubscribe();
    }

    show(): void {
        this.visible = true;
        this.visibleChange.emit(true);
    }

    hide(): void {
        this.visible = false;
        this.visibleChange.emit(false);
    }

    toggle(): void {
        this.visible = !this.visible;
    }
}
